import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const createRouter = function () {
  return new Router(
    {
      mode: 'history',
      scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
          return savedPosition
        } else {
          return {x: 0, y: 0}
        }
      },
      routes: [
        {
          path: '/',
          name: 'Index',
          component: () => import('@/components/view/index'),
        },
        {
          path: '/search',
          name: 'Search',
          component: () => import('@/components/view/search/search.vue')
        },
        {
          path: '/search-detail/:articleId',
          name: 'SearchDetail',
          props: true,
          component: () => import('@/components/view/search/Detail.vue')
        },
        {
          path: '/about-us',
          name: 'AboutUs',
          redirect: '/about-us/index',
          component: () => import('@/components/view/aboutUs/Index.vue'),
          children: [
            {
              path: 'index',
              name: 'AboutUsCatePage',
              component: () => import('@/components/view/aboutUs/CatePage.vue'),
            },
            {
              path: 'company-introduction',
              name: 'AboutUsIndex',
              component: () => import('@/components/view/aboutUs/AboutUs.vue'),
            },
            // {
            //   path: 'expert-team',
            //   name: 'AboutUsExpertTeam',
            //   component: () => import('@/components/view/aboutUs/ExpertTeam.vue'),
            // },
            {
              path: 'mile-stone',
              name: 'AboutUsMilestone',
              component: () => import('@/components/view/aboutUs/Milestone.vue'),
            },
            {
              path: 'honor',
              name: 'AboutUsHonor',
              component: () => import('@/components/view/aboutUs/Honor.vue'),
            },
            {
              path: 'resource-matrix',
              name: 'ResourceMatrix',
              component: () => import('@/components/view/aboutUs/ResourceMatrix.vue'),
            },
            {
              path: 'expert-detail/:articleId',
              name: 'ExpertDetail',
              props: true,
              component: () => import('@/components/view/aboutUs/ExpertDetail.vue')
            }
          ]
        },
        {
          name: 'ContactUs',
          path: '/contact-us',
          component: () => import('@/components/view/contactUs/contactUs.vue')
        },
        {
          path: '/progress-show',
          name: 'ProgressShow',
          redirect: '/progress-show/index',
          component: () => import('@/components/view/progressShow/Index.vue'),
          children: [
            {
              path: 'cate-list/:cateId',
              props: true,
              name: 'CateList',
              component: () => import('@/components/view/progressShow/CaseShow.vue'),
            },
            {
              path: 'index',
              name: 'ProgressShowIndex',
              component: () => import('@/components/view/progressShow/catePage.vue'),
            },
            {
              path: 'detail/:articleId',
              props: true,
              name: 'ProgressShowDetail',
              component: () => import('@/components/view/progressShow/Detail.vue')
            }
          ]
        },
        {
          path: '/gov-service',
          name: 'GovernmentService',
          redirect: '/gov-service/index',
          component: () => import('@/components/view/governmentService/Index.vue'),
          children: [
            {
              path: 'index',
              name: 'GovernmentServiceIndex',
              component: () => import('@/components/view/governmentService/catePage.vue'),
            },
            {
              path: 'detail/:typeIdx?',
              props: true,
              name: 'GovernmentServiceDetail',
              component: () => import('@/components/view/governmentService/Detail.vue'),
            }
          ]
        },
        {
          path: '/ent-service',
          name: 'EnterpriseService',
          redirect: '/ent-service/index',
          component: () => import('@/components/view/enterpriseService/Index.vue'),
          children: [
            {
              path: 'index',
              name: 'EnterpriseServiceIndex',
              component: () => import('@/components/view/enterpriseService/catePage.vue'),
            },
            {
              path: 'detail/:typeIdx?',
              props: true,
              name: 'EnterpriseServiceDetail',
              component: () => import('@/components/view/enterpriseService/Detail.vue'),
            }
          ]
        },
        {
          path: '/news-focus',
          name: 'NewsFocus',
          redirect: '/news-focus/index',
          component: () => import('@/components/view/newsFocus/Index.vue'),
          children: [
            {
              path: 'cate-list/:cateId',
              props: true,
              name: 'NewsFocusCateList',
              component: () => import('@/components/view/newsFocus/CaseShow.vue'),
            },
            {
              path: 'index',
              name: 'NewsFocusIndex',
              component: () => import('@/components/view/newsFocus/catePage.vue'),
            },
            {
              path: 'detail/:articleId',
              props: true,
              name: 'NewsFocusDetail',
              component: () => import('@/components/view/newsFocus/Detail.vue')
            }
          ]
        },
        // {
        //   path: '/news-focus/:articleId',
        //   props: true,
        //   name: 'NewsFocus',
        //   component: () => import('@/components/view/newsFocus/Index.vue')
        // },
        // {
        //   path: '/news-focus-list',
        //   name: 'NewsFocusList',
        //   component: () => import('@/components/view/newsFocus/List.vue')
        // },
        {
          path: '/developing',
          name: 'Developing',
          component: () => import('@/components/view/developing/developing')
        },
        {
          path: '/recruitment',
          name: 'Recruitment',
          component: () => import('@/components/view/recruitment/recruitment')
        }
      ],
    },
  )
}

const r = createRouter()

export { createRouter }
export default r

